// Module
var code = "<div v-if=\"!order.isOmsFlow\" class=\"thankYou_openInvoice\"> <router-link class=\"thankYou_openInvoiceLink t-thankYouPage_invoice\" target=\"_blank\" :to=\"getLink('invoice', { provider: theme.provider.name })\">{{ t('thankYou_openInvoice') }}</router-link> </div> ";
// Exports
export default code;